import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-global-serive-enabled',
  templateUrl: './global-serive-enabled.component.html',
  styleUrls: ['./global-serive-enabled.component.scss']
})
export class GlobalSeriveEnabledComponent implements OnInit {

  constructor(private router:Router,private service:ApifirstService) { }
  public serviceName=''
  ngOnInit(): void {
    this.service.selectedGlobalServices.subscribe(data => {
      this.serviceName=data
   } )
  }

}
